<template>
	<div>
	  <el-menu class="navbar" mode="horizontal">
		<!-- <hamburger
		  class="hamburger-container"
		  :toggleClick="toggleSideBar"
		></hamburger> -->
		<breadcrumb></breadcrumb>
		<div class="time-container">{{languageData.dqtime[languageType]}}{{userInfo.shop_expire}}</div>
		<div class="avatar-container avatar-language">
		  <!-- 切换语言 -->
		  <div class="avatar-wrapper-mini" @click.stop="changeLanguage">
			<img class="mini-img" :src="language" />
		  </div>
		  <div class="avatar-wrapper-mini" @click.stop="changeLog">
				<i class="el-icon-question mini-img question-big" ></i>
		  </div>
		</div>
		<el-dropdown class="avatar-container" >
		  <!-- 消息 -->
		   
		  <!-- 用户 -->
		  <div class="avatar-wrapper">
			<span class="topUserName">{{userInfo.nickname}}</span>
		  </div>
		  <el-dropdown-menu class="user-dropdown" slot="dropdown">
			<router-link class="inlineBlock" to="/">
			  <el-dropdown-item> {{languageData.spck[languageType]}} </el-dropdown-item>
			</router-link>
			<el-dropdown-item divided>
			  <span @click="logout" style="display: block">{{languageData.tuic[languageType]}}</span>
			</el-dropdown-item>
		  </el-dropdown-menu>
		</el-dropdown>
	  </el-menu>
	  <div>
	  
	  <el-dialog
	  :visible.sync="dialogVisible"
	  width="95%"
	  center>
		<div v-html="contentinfo.content" style="height: 58vh;overflow-y:scroll;">
		</div>
	  <span slot="footer" class="dialog-footer">
		<el-button type="primary" @click="dialogVisible = false">{{ languageData.qd[languageType] }}</el-button>
	  </span>
	</el-dialog>

	  </div>
	
	</div>

</template>

<script>
import { mapGetters } from "vuex";
import { getpageContent,getInfo} from "@/api/urlApi";

import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import newsNavbar from "@/assets/images/newsNavbar.png";
import language from "@/assets/images/language.png";
import avatar from "@/assets/images/avatar.png";
import { setCookie, getCookie } from "@/utils/support";
import languageData from "@/utils/language.json";
export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  data() {
    return {
      newsNavbar,
      language,
      avatar,
	  dialogVisible: false,
	  contentinfo:{},
	  userInfo:{},
      // 语言类型
      languageType: getCookie("language"),
      languageData,
    };
  },
  computed: {
    ...mapGetters(["sidebar"]),
  },
  created() {


    this.getList();
	this.getUserInfo();
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
	getList() {
		let param = {
			pagetype:5,
		};
		getpageContent(param).then((response) => {
			this.contentinfo = response.data.info;
		});
    },
	getUserInfo(){
		getInfo().then((response) => {
			this.userInfo = response.data.user;
		});
	
	},
	
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    changeLanguage() {
      let languageType = this.languageType;
      if (languageType == 0) {
        setCookie("language", 1, 15);
        location.reload();
      } else {
        setCookie("language", 0, 15);
        location.reload();
      }
    },
	changeLog(){
		this.dialogVisible  = true;
	},
	handleClose(){
	
	},
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 40px;
  line-height: 40px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 40px;
    height: 40px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
}
.question-big{
    color: #fff;
	display:block;
	font-size:25px;

}
.topUserName{width:120px;overflow:hidden;margin-top:10px;}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue